import sgWildsComponent, {WILD_COMBINATIONS} from "components/wilds/sg-wilds-component";
import {RequireStageLoadCommand} from "slotworks/commands/loading/require-stage-load-command";
import Components from "slotworks/components/components";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import {Services} from "slotworks/services/services";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";
import Sequence from "slotworks/utils/contracts/sequence";

export default class SGCombineWilds extends State {

    public onEnter() {

        RequireStageLoadCommand(1).then(() => {

            const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;
            const wilds = record.grid.map(reel => reel[0].indexOf("expanded_") > -1 || reel.indexOf("wild") > -1);

            if (wilds[1] && wilds[2] && !wilds[3] && !this.isCombined([1, 2], record)) {
                this.animateCombine([WILD_COMBINATIONS.RA, WILD_COMBINATIONS.MAAT], [1, 2]);
            } else if (!wilds[1] && wilds[2] && wilds[3] && !this.isCombined([2, 3], record)) {
                this.animateCombine([WILD_COMBINATIONS.MAAT, WILD_COMBINATIONS.KHNUM], [2, 3]);
            } else if (wilds[1] && wilds[2] && wilds[3] && this.isCombined([1, 2], record) && !this.isCombined([1, 2, 3], record)) {
                this.animateCombine([WILD_COMBINATIONS.RA_MAAT, WILD_COMBINATIONS.KHNUM], [1, 2, 3]);
            } else if (wilds[1] && wilds[2] && wilds[3] && this.isCombined([2, 3], record) && !this.isCombined([1, 2, 3], record)) {
                this.animateCombine([WILD_COMBINATIONS.RA, WILD_COMBINATIONS.MAAT_KHNUM], [1, 2, 3]);
            } else if (wilds[1] && wilds[2] && wilds[3] && !this.isCombined([1, 2, 3], record)) {
                this.animateCombine([WILD_COMBINATIONS.RA, WILD_COMBINATIONS.MAAT, WILD_COMBINATIONS.KHNUM], [1, 2, 3]);
            } else {
                this.complete();
            }
        });
    }

    private animateCombine(combination: string[], combinedReelIndexes: number[]): void {
        new Sequence<void>([
            () => sgWildsComponent.playCombineAnimation(combination, combinedReelIndexes),
            () => Contract.wrap(() => this.combineWilds(combinedReelIndexes)),
            () => Contract.wrap(() => this.complete()),
        ]).execute();
    }

    private combineWilds(reels: number[]): void {
        const combinedSymbolId = "expanded_" + reels.map(index => ++index).join("_");
        const masterSymbol = Components.matrix.getSymbol(reels[0], 0);
        if (reels.length === 3) {
            Services.sound.customEvent("three_wilds");
        }
        masterSymbol.setSymbol(combinedSymbolId);
        for (const reel of reels) {
            for (let row = 0; row < 3; row++) {
                const symbol = Components.matrix.getSymbol(reel, row);

                if (symbol !== masterSymbol) {
                    symbol.setSymbol(combinedSymbolId);
                    symbol.setVisible(false);
                    symbol.static();
                }
            }
        }
    }

    private isCombined(reels: number[], record: SpinRecord): boolean {
        let isCombined:boolean = reels.length === reels.filter(index => record.grid[index][0].indexOf("expanded_") > -1).length;
        return isCombined;
    }
}
